// src/pages/TourDetails.js

import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PSpinner } from "@porsche-design-system/components-react";
import { setItem } from "../../assets/utils/js/storage.js"; // Importa las funciones de almacenamiento
import "./TourInformation.css";
import InformationDescriptionSide from "Components/InformationFolder/InformationDescriptionSide/InformationDescriptionSide";
import InformationBookSide from "Components/InformationFolder/InformationBookSide/InformationBookSide";
import { AuthContext } from "MainApp/assets/utils/context/AuthContext.js";
import { ToursContext } from "MainApp/assets/utils/context/TourContext.jsx";
import axiosInstance2 from "axiosConfig";

const TourDetails = ({ isPhone }) => {
  const { setToken, setOriginUrl } = useContext(AuthContext);

  const { slug } = useParams(); // Extrae el 'slug' desde los parámetros de la URL
  console.log("slug", slug);
  const [tour, setTour] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Estilos condicionales basados en si es un dispositivo móvil o no
  const tourInformationStyling = {
    display: isPhone ? "flex" : "grid",
  };
  const { getTourBySlug } = useContext(ToursContext);

  useEffect(() => {
    let mounted = true; // Variable para evitar actualizaciones de estado si el componente se desmonta
    let timerId = null;

    const cachedTour = getTourBySlug(slug);
    console.log("cachedTour", cachedTour);

    if (cachedTour) {
      console.log("Using cache");
      setTour(cachedTour);
      setLoading(false);
    } else {
      console.log("Fetching...");
      const fetchTour = async () => {
        try {
          // Solicitar al endpoint público para obtener los detalles del tour
          console.log("response");
          const response = await axiosInstance2.get(`/tour/details/${slug}`);
          console.log("response", response.data);

          if (response.data) {
            const tourFromServer = response.data;
            console.log("tourFromServer 2222");
            console.log(response);

            // Seteamos el token de autenticación de acceso público
            await setToken(tourFromServer.token);
            await setOriginUrl(tourFromServer.originUrl);

            // Construir el objeto del tour con todos los campos necesarios
            const tourData = {
              id: tourFromServer.tourUUID,
              title: tourFromServer.name,
              slug: tourFromServer.slug, // Utilizar el slug proporcionado por el backend
              description: tourFromServer.description,
              images: Array.isArray(tourFromServer.images)
                ? tourFromServer.images.map((image) =>
                    image.startsWith("http://") || image.startsWith("https://")
                      ? image
                      : `${process.env.REACT_APP_API_BASE_URL}${image}`
                  )
                : [],
              price: tourFromServer.priceMin,
              sprice: tourFromServer.stripe_price_id,
              duration: tourFromServer.duration,
              durations: Array.isArray(tourFromServer.durations)
                ? tourFromServer.durations
                : [],
              personsInsteadTime: Boolean(
                tourFromServer.uses_people_instead_of_times
              ),
              vehiclesSmall: Boolean(
                tourFromServer.show_vehicles_as_lowest_capacity
              ),
              usesPeopleAndTimesPricing: Boolean(
                tourFromServer.uses_people_and_times_pricing
              ),
              uses_people_and_times_pricing: Boolean(
                tourFromServer.uses_people_and_times_pricing
              ),
              preferLowerPeoplePriceTier: Boolean(
                tourFromServer.prefer_lower_people_price_tier
              ),
              prefer_lower_people_price_tier: Boolean(
                tourFromServer.prefer_lower_people_price_tier
              ),
              frontendUsesPeoplePriceTiers: Boolean(
                tourFromServer.frontend_uses_people_price_tiers
              ),
              frontend_uses_people_price_tiers: Boolean(
                tourFromServer.frontend_uses_people_price_tiers
              ),
            };
            console.log("tourFromServer", tourFromServer);

            // Guardamos en caché antes de actualizar estado
            await setItem(`tour_${slug}`, tourData);

            if (mounted) {
              setTour(tourData);
              setLoading(false);
            }
          } else {
            if (mounted) {
              console.log("InformationDescriptionSide tour");
              navigate("/404"); // Redirigir a la página 404 si no se encuentra el tour
            }
          }
        } catch (err) {
          console.error("Error fetching tour:", err);
          if (mounted) {
            setError("Tour not found.");
            setLoading(false);
            // Opcional: Redirigir a la página 404
            // navigate('/404');
          }
        }
      };

      // Esperar 1 segundo antes de ejecutar fetchTour()
      timerId = setTimeout(() => {
        fetchTour();
      }, 1000);
    }

    return () => {
      mounted = false;             // Evitar actualizaciones de estado después del desmontaje
      if (timerId) clearTimeout(timerId); // Limpiar el timeout si aún no ha ejecutado
    };
  }, [slug, navigate, getTourBySlug, setToken, setOriginUrl]);

  if (loading) {
    // Mostrar un spinner mientras se carga la información del tour
    return (
      <div className="spinnerContainerInfo">
        <PSpinner />
      </div>
    );
  }

  if (error) {
    return <div className="errorMessage">{error}</div>;
  }

  if (!tour) {
    return <div>No tours available.</div>;
  }

  return (
    <div className="tourInformation" style={tourInformationStyling}>
      <InformationDescriptionSide tour={tour} isPhone={isPhone} />
      {!isPhone && <InformationBookSide tour={tour} />}
    </div>
  );
};

export default TourDetails;
